import { PublicRoutes } from '@/models/appRoutes';
import { Permission } from '@/models/Permission';
import { Role } from '@/models/role';
import { AuthService } from '@/services/auth.service';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const AuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    return router.createUrlTree(['/', PublicRoutes.Login], {
      queryParams: { returnUrl: state.url },
    });
  }

  const segments = state.url.split('/').filter(Boolean);
  const requiredPermissions = (route.data?.['permission'] ?? `${segments[0]}:${segments[1]}`) as
    | Permission
    | Permission[];
  const isAllowed = () =>
    authService.hasRoles([Role.SYSTEMADMIN]) ||
    authService.hasPermissions(
      Array.isArray(requiredPermissions) ? requiredPermissions : [requiredPermissions],
    );

  return isAllowed() || router.createUrlTree(['/', PublicRoutes.Forbidden]);
};
